<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>词书分类</span></div>
            </el-form-item>

            <el-form-item>
              <el-button size="small" type="primary" plain @click="handleEdit()">添加
              </el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <!--列表-->
      <el-table border ref="multipleTable" :data="tableData" :header-cell-style="headStyle" tooltip-effect="dark"
        style="width: 100%; " v-loading="loading">
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="id" label="分类id" align="center" width="140"></el-table-column>
        <el-table-column prop="image" label="背景图" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.image" alt="" srcset="" width="60" height="60" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="分类名称" align="center"></el-table-column>

        <el-table-column prop="is_show" label="状态" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.status == 0 ? '不显示' : '显示' }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" align="center"></el-table-column>

        <el-table-column prop="jtime" label="更新时间" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.updateTime | timestampToTime }}</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="160">
          <template slot-scope="scope">

            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">修改 </el-button>
            <el-button size="mini" type="danger" @click="handleEditdel(scope.row.id)">删除 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>

    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="30%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">
                <el-form-item label="分类名称" prop="name">
                  <el-input v-model="editForm.params.name" placeholder="请输入分类名称"></el-input>
                </el-form-item>
                <el-form-item label="背景图：" prop="logo">
                  <el-upload class="avatar-uploader" name="files" :action="imagesrc" :headers="uploadHeader"
                    :show-file-list="false" :on-success="licenseSuccess" :before-upload="beforeAvatarUpload">
                    <img v-if="editForm.params.image" :src="editForm.params.image" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-form-item>


                <el-form-item label="是否显示" prop="name">
                  <el-radio-group v-model="editForm.params.status">
                    <el-radio :label="0">不显示</el-radio>
                    <el-radio :label="1">显示</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="排序" prop="name">
                  <el-input v-model="editForm.params.sort" placeholder="排序权重"></el-input>
                </el-form-item>
              </div>
            </el-col>

          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="goon" :loading="loading" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>

  </div>
</template>
<script>
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { categorylist, categoryadd, categoryupdate, categorydelete, imagesrc, getUploadHeader } from "../../api/userMG";
export default {
  data() {
    return {
      title: "编辑信息",
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },

      editFormVisible: false,
      imagesrc: "", //图片
      uploadHeader: {},
      tableData: [], //表格数据
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10
        },
      },
      rules: [],
      editForm: {
        data: {},
        params: {
          "id": 0,
          "image": "",
          "name": "",
          "sort": 100,
          "status": 0,
          "level": 1,
          //"difficulty": 3
        },
      }

    };
  },
  components: {
    Pagination
  },
  created() {
    this.imagesrc = imagesrc;//上传地址
    this.uploadHeader = getUploadHeader()
    //数据列表
    this.getlist(this.formInline);
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },
    //显示数据
    getlist(parameter) {
      this.loading = true;
      categorylist(parameter)
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.tableData = res.data.records;
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;
            this.pageparm.total = res.data.total;
            // console.log(this.tableData)
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          this.editFormVisible = false
          // done();
        })
        .catch((_) => { });
    },
    //上传头像
    licenseSuccess(response, file) {
      this.editForm.params.image = response.data[0].url
    },
    //限制上传的文件
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是 JPG 格式或者png格式!');
      }
      return isJPG || isPNG;
    },

    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {//修改

        this.editForm = {

          data: {},
          params: {
            'id': row.id,
            "image": row.image,
            "name": row.name,
            "sort": row.sort,
            "status": row.status,
            "level": 1,
            // "difficulty": 3
          },
        }

      } else {//添加   
        this.editForm = {
          data: {},
          params: {
            "image": "",
            "name": "",
            "sort": 100,
            "status": 1,
            "level": 1,
            //"difficulty": 3
          },
        }

      }
    },
    //提交添加，修改
    submitForm(info) {

      debounce(() => {
        if (this.editForm.params.id == 0) {
          categoryadd(this.editForm)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading2 = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        } else {
          categoryupdate(this.editForm)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading2 = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        }


      }, 1500);
    },
    handleEditdel(id) {
      let data = {
        "data": {},
        "params": id,
      }
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          categorydelete(data) //删除
            .then((res) => {
              console.log("d", res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getlist(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/book/category.vue